import ReferenceService from '@/general/services/ReferenceService';
import { ListCache } from '@/general/utils/cache';
import { BrandId } from '@/shared/models/Brand';
import serviceEvents, { UserLoggedOut } from '@/shared/services/events/serviceEvents';
import { mergeInto, removeById } from '@/shared/utils';
import { withRawResults } from '@/shared/utils/component';
import TestDriveClient from '../client/TestDriveClient';
import Dossier from '../models/Dossier';
import DossierDetailContext from '../models/DossierDetailContext';
import TestDrive, { TestDriveId } from '../models/TestDrive';
import TestDriveData from '../models/TestDriveData';
import TestDriveReason from '../models/TestDriveReason';

class TestDriveService {
  private reasons = new ListCache(withRawResults(TestDriveClient.loadReasons));

  constructor() {
    serviceEvents.on(UserLoggedOut, () => this.reasons.clear());
  }

  async loadAll(dossier: Dossier): Promise<Array<TestDrive>> {
    if (dossier.hasTestDrives) {
      return TestDriveClient.loadAll(dossier.id, id => ReferenceService.getUser(id));
    } else {
      return [];
    }
  }

  loadReasons(brandId: BrandId): Promise<Array<TestDriveReason>> {
    return this.reasons.get(brandId);
  }

  async create(data: TestDriveData, context: DossierDetailContext): Promise<TestDrive> {
    const testDrive = await TestDriveClient.create(data, context.dossier.id, id => ReferenceService.getUser(id));
    context.testDrives.push(testDrive);
    return testDrive;
  }

  async update(data: TestDriveData, testDrive: TestDrive, context: DossierDetailContext): Promise<TestDrive> {
    const updatedTestDrive = await TestDriveClient.update(data, testDrive);
    mergeInto(updatedTestDrive, context.testDrives);
    return updatedTestDrive;
  }

  async remove(id: TestDriveId, context: DossierDetailContext): Promise<void> {
    await TestDriveClient.remove(id);
    removeById(context.testDrives, id);
  }
}

export default new TestDriveService();